module.exports = __webpack_public_path__ + "static/media/ht.2b388e39.svg";